export const onFatalError = (error: any) => {
  // @ts-ignore
  const userLang = navigator.language || navigator.userLanguage
  let errorMessage = 'Fatal error. Please contact administrator.'
  if (userLang === 'sk-SK') {
    errorMessage = 'Fatálna chyba. Prosím kontaktujte administrátora.'
  }
  const appDiv = document.getElementById('app')
  appDiv?.insertAdjacentHTML(
    'beforeend',
    `<div style='color:red;text-align:center;font-weight:bold;margin:20px;'>${errorMessage}</div>`
  )
  console.error(error)
}
